import { Controller } from '@hotwired/stimulus'
import { clickedInteractiveTarget } from '../helpers/interactive_click'

export default class extends Controller {
  static targets = ['element', 'icon']
  static values = {
    attribute: String,
    preventDefault: { type: Boolean, default: false }
  }

  toggle (e) {
    if (clickedInteractiveTarget(e)) {
      return
    }

    if (this.preventDefaultValue) {
      e.preventDefault()
    }

    this.elementTargets.forEach((element) => {
      if (element.hasAttribute(this.attributeValue)) {
        element.removeAttribute(this.attributeValue)
      } else {
        element.setAttribute(this.attributeValue, true)
      }
    })
    this.syncIcons()
  }

  set () {
    this.elementTargets.forEach((element) => {
      element.setAttribute(this.attributeValue, true)
    })
    this.syncIcons()
  }

  unset () {
    this.elementTargets.forEach((element) => {
      element.removeAttribute(this.attributeValue)
    })
    this.syncIcons()
  }

  syncIcons () {
    const open = this.elementTargets.some((element) => !element.hasAttribute(this.attributeValue))
    this.iconTargets.forEach((icon) => icon.classList.toggle('rotate-180', open))
  }
}
